/**
 * 静态统计值单元格  StatisticsBubble
 */
import React, { useMemo } from 'react';
import { useIntl } from "umi";
import CommonBubble from '@home/components/CommonBubble';
import { STATISTICS_PREFIX } from "../../../consts";
import './index.scss';

interface IStatisticsBubbleProps {
  statistics: string;
  taskId?: string;
  isFullscreen?: boolean;
}
const StatisticsBubble = (props: IStatisticsBubbleProps) => {
  const { statistics, taskId, isFullscreen } = props || {};
  const { formatMessage } = useIntl();

  const key = useMemo(() => {
    const map: any = {
      'Avg': 'avg',
      'Avg (≠Null)': 'avgNotNull',
      'Max Value': 'max',
      'Min Value': 'min',
      'Sum': 'sum'
    };
    return map[statistics?.replace(STATISTICS_PREFIX, '')] || statistics;
  }, [statistics]);

  const popupClassName = useMemo(() => isFullscreen && taskId ? `dbl-table-statistics-${key}-${taskId}` : "", [isFullscreen, key, taskId]);

  return <CommonBubble
    placement='top'
    content={formatMessage({id: `dbl_chart_statistics_${key}_tooltip`})}
    // {...(isFullscreen && taskId ? { popupContainer: (document.querySelector(`.${popupClassName}`) as any) || document.body } : {})}
  >
    <span className={`dbl-table-statistics-${key} ${popupClassName} `}>{formatMessage({id: `dbl_chart_statistics_${key}`})}</span>
  </CommonBubble>;
};

export default StatisticsBubble;